import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Col, Row, Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getCookie } from "typescript-cookie";
import { faFilter, faFunnelDollar, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Campaign: React.FC = () => {
  const navigate = useNavigate();
  const Organization_Id = getCookie("organizationId");
  const Token = getCookie("authToken");
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [filteredCampaigns, setFilteredCampaigns] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    fetchCampaigns(1);
    // eslint-disable-next-line
  }, []);

  const fetchCampaigns = async (pageNumber: number) => {
    if (Organization_Id && Token) {
      try {
        const apiUrl = `${process.env.REACT_APP_API_URL}api/campaigns?organization_id=${Organization_Id}&page=${pageNumber}`;
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        });
        const campaignsData = response.data.data || [];

        if (campaignsData.length > 0) {
          setCampaigns((prevCampaigns) => [...prevCampaigns, ...campaignsData]);
          setFilteredCampaigns((prevCampaigns) => [
            ...prevCampaigns,
            ...campaignsData,
          ]);
        }
        if (campaignsData.length === 0) {
          setHasMore(false);
        }
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      }
    }
  };

  const handleSearch = (searchValue: string) => {
    setSearchTerm(searchValue);
    const searchResult = campaigns.filter((campaign) =>
      campaign.title.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredCampaigns(searchResult);
  };

  const loadMoreCampaigns = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchCampaigns(nextPage);
  };

  return (
    <div className="kiosk-container mt-4 overflow-hidden">
      <Row className="align-items-center mb-4 mt-1">
        <Col>
          <h1 className="theme-color-kiosk-title">
            <strong>Campaign List</strong>
          </h1>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <InputGroup className="me-2 custom-search-input w-50" style={{ borderRadius: "8.5px", border: "0.5px solid #8B8C8D" }}>
            <InputGroup.Text className="uniform-back-btn border-0 custom-search-icon">
              <FontAwesomeIcon
                icon={faSearch}
                style={{
                  color: "white",
                  height: "18.04px",
                  width: "18.04px",
                }}
              />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search campaign"
              aria-label="Search campaign"
              value={searchTerm}
              className="custom-search-kiosk"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </InputGroup>
          <button className="btn btn-icon uniform-back-btn">
            <FontAwesomeIcon
              icon={faFilter}
              style={{
                color: "white",
                height: "18.04px",
                width: "18.04px",
              }}
            />
          </button>
        </Col>
      </Row>
      <Row>
        {filteredCampaigns.map((campaign, index) => (
          <Col xs={4} key={index} className="mt-5">
            <Card
              className="campaignlist-card"
              onClick={() => navigate(`${campaign.id}/campaign-view`)}
            >
              <Card.Body className="py-3 text-center">
                <Card.Text className="m-0 fs-3">
                  <b>{campaign.title}</b>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {hasMore && (
        <div className="d-flex justify-content-center mt-4 mb-5">
          <button className="custom-load-more-btn py-3 px-4" onClick={loadMoreCampaigns}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default Campaign;
